import React from 'react'
import CustomPageEditor from './CustomPageEditor'

function CreateCustomPage() {
  return (
    <CustomPageEditor />
  )
}

export default CreateCustomPage